import React from 'react';
import Icon from '../../../components/AppIcon';

const ScorePreviewBadge = ({ score, role }) => {
  const getScoreColor = () => {
    if (score >= 700) return 'from-[var(--color-success)] to-[var(--color-primary)]';
    if (score >= 400) return 'from-[var(--color-primary)] to-[var(--color-secondary)]';
    return 'from-[var(--color-secondary)] to-[var(--color-accent)]';
  };

  const getScoreLabel = () => {
    if (score >= 700) return 'Elite';
    if (score >= 400) return 'Rising Star';
    if (score >= 200) return 'Emerging';
    return 'Newcomer';
  };

  if (role !== 'influencer') return null;

  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-2xl p-5 flex items-center gap-4">
      <div
        className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${getScoreColor()} flex flex-col items-center justify-center shadow-lg flex-shrink-0`}
      >
        <span className="text-white text-lg font-bold leading-none">{score}</span>
        <span className="text-white/80 text-[9px] font-medium mt-0.5">SCORE</span>
      </div>
      <div>
        <div className="flex items-center gap-2 mb-1">
          <Icon name="Zap" size={14} color="var(--color-accent)" />
          <span className="text-xs font-semibold text-[var(--color-accent)] uppercase tracking-wide">SocialCents Score</span>
        </div>
        <p className="text-base font-bold text-[var(--color-foreground)]">{getScoreLabel()}</p>
        <p className="text-xs text-[var(--color-muted-foreground)] mt-0.5">
          Complete your profile to boost your score
        </p>
      </div>
    </div>
  );
};

export default ScorePreviewBadge;
